import { Alpine } from '../../../../vendor/livewire/livewire/dist/livewire.esm';


/**
 * modifiers
 *
 * width: <n>xl, <n>lg, <n>md, <n>sm - (default = 2xl)
 *
 * close action: closeWhenClickOutside - (default = false)
 *
 * vertical align: centered, top - (default = centered)
 *
 * example of usage when you want a modal with 6xl of width and aligned to top:
 * x-modal.6xl.top="path.view"
 *
 * example of usage when you want a modal with 2xl of width and centralized but that don't close when click out side of container:
 * x-modal.closeWhenClickOutside="path.view"
 */
Alpine.directive('modal', (element, {expression, modifiers}, {evaluate}) => {
    element.addEventListener('click', ($openElement) => {
        if (element.getAttribute('disabled')) {
            return;
        }

        $openElement.stopPropagation();

        let viewParams = []
        if (element.getAttribute('modal-params') !== null) {
            viewParams = evaluate(element.getAttribute('modal-params'));
        }

        const viewName = expression;
        const maxWidth = modifiers.find((modifier) => modifier.includes('xl') || modifier.includes('lg') || modifier.includes('md') || modifier.includes('sm'));
        const centered = !modifiers.includes('top');


        Alpine.store('modal').withOpacity = !modifiers.includes('withoutopacity');
        Alpine.store('modal').withTransition = !modifiers.includes('without-transition');

        Alpine.store('modal').maxWidth = maxWidth ?? '2xl';

        Alpine.store('modal').centered = centered;

        Livewire.dispatch('modal::open', { viewName, params: viewParams });

        addClickOutsideEventListner(modifiers.includes('closewhenclickoutside'));
    })
})


const addClickOutsideEventListner = (closeWhenClickOutside) => {
    if (!closeWhenClickOutside) {
        return ;
    }

    return document.addEventListener('click', ($clickElement) => {
        if (document.getElementById('modalContent') && !document.getElementById('modalContent')?.contains($clickElement.target) && Alpine.store('modal').isOpen) {
            Livewire.dispatch('modal::close');
        }
    })
}
